import { render, staticRenderFns } from "./pl-time-spin.vue?vue&type=template&id=bbb0a3f4&"
import script from "./pl-time-spin.vue?vue&type=script&lang=js&"
export * from "./pl-time-spin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports